<template>
  <button id="btnGuardar" class="btn-guardar">
    {{ texto }}
  </button>

</template>

<script>

export default {
  props: {
    texto: {
      type: String,
      default: "Agregar"
    }
  }
}
</script>

<style>
.btn-guardar {
  background-color: #198754;
  border: none;
  color: white;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
}

.btn-guardar:hover {
  background-color: #146c43;
}

.btn-guardar i {
  font-size: 1.2em;
}
</style>